export default "__VITE_ASSET__BQCGTThC__ 400w, __VITE_ASSET__Cs4QEGsQ__ 800w, __VITE_ASSET__C95qSkhl__ 1280w";